import { Box, Breadcrumbs, ImageList, ImageListItem, ImageListItemBar, Typography } from "@mui/material";
import Link from '@mui/material/Link';
import { useState } from "react";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { LayoutState, PicDimH, PicDimW, PicWidth } from "../Layout";
import { ui } from "../i18n";
import { ImageDesc } from "./GalleryData";
import Painting from "./Painting";

type Lang = "de" | "en";

const landscape = "landscape";
const portrait = "portrait";

const size = PicWidth;
const wh = size * PicDimW / PicDimH;

// The behavior of the component is controlled by two elements:
//     paintingName: name of the painting shown ("" = no painting)
//     params.serie: name of the series shown ("all" = summary of series)
export default function GalleryMobile(params: {layoutState: LayoutState, serie: string | undefined, lang: string, paintingName: string, heading: string, fullsize: boolean, itemData: ImageDesc[]}) {
    const layoutState = params.layoutState;
    const handle = useFullScreenHandle();
    const [paintingName, setPaintingName] = useState(params.paintingName);
    const navigate = useNavigate();

    const isPainting = (paintingName !== "");
    const fullsize = handle.active && isPainting;

    return (
        <Box>
            <Box sx={{ maxWidth: layoutState.GalleryMaxWidth(), paddingTop: layoutState.GalleryPaddingTop(), paddingLeft: layoutState.GalleryPaddingLeft() }}>
                <Breadcrumbs separator="›">
                    {params.serie !== "all" &&
                        <Box>
                            <Link component={RouterLink as any} to="/gallery/all" underline="none" color="inherit" href="/">
                                <Typography variant="body2" sx={{ fontSize: "0.925rem", display: "block" }}>
                                    {ui[params.lang].Gallery.cycles}
                                </Typography>
                            </Link>
                        </Box>
                    }
                    <Typography variant="body2" sx={{ fontSize: "0.925rem", display: "block" }}>
                        {params.heading}
                    </Typography>
                </Breadcrumbs>
            </Box>

            <Box sx={{}}>
                <ImageList sx={{ padding: layoutState.GalleryPaddingImageList() }} cols={1} gap={45} >
                    {params.itemData.map((item) => (
                        <ImageListItem key={item.name} >
                            <img
                                src={"/img/" + item.image + ".jpg"}
                                loading="lazy"
                                style={{ cursor: "pointer", boxShadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)" }}
                                onClick={() => {
                                    if (params.serie === "all") {
                                        navigate("/gallery/" + item.name);
                                    }
                                    else {
                                        handle.enter();
                                        setPaintingName(item.name);
                                    }
                                }}
                            />

                            <ImageListItemBar position="below" sx={{ paddingTop: "10px", textAlign: "center", maxWidth: "100%", background: "inherit" }}
                                title={item.title[params.lang as Lang]}
                            />
                        </ImageListItem>
                    ))}
                </ImageList>
            </Box >
            <FullScreen handle={handle}>
                {fullsize &&
                    <Painting name={paintingName} fromTour={false} fullscreenhandle={handle}></Painting>
                }
            </FullScreen>
        </Box>
    );
}


